// Quick Add to Cart functionality
// Handles adding products to cart directly from product cards

document.addEventListener("DOMContentLoaded", () => {
  // Event delegation for quick add buttons
  document.addEventListener("click", (event) => {
    if (event.target.classList.contains("quick-add-size-btn")) {
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()

      quickAddToCart(event, event.target)
      return false
    }
  })

  document.addEventListener("click", (event) => {
    if (event.target.closest(".quick-add-overlay")) {
      event.stopPropagation()
    }
  })
})

function quickAddToCart(event, button) {
  event.preventDefault()
  event.stopPropagation()
  event.stopImmediatePropagation()

  const variantId = button.getAttribute("data-variant-id")
  const productId = button.getAttribute("data-product-id")
  const loadingElement = document.getElementById("loading-" + productId)

  if (!variantId || button.disabled) return

  // Show loading
  if (loadingElement) {
    loadingElement.classList.add("active")
  }

  // Disable button temporarily
  button.disabled = true

  // Create form data
  const formData = new FormData()
  formData.append("id", variantId)
  formData.append("quantity", 1)

  // Add to cart via AJAX
  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      // Success - update cart drawer or show notification
      if (window.theme && window.theme.cartDrawer) {
        window.theme.cartDrawer.refresh()
      }

      // Show success message
      showQuickAddNotification("Produto adicionado ao carrinho!", "success")

      // Update cart count if exists
      updateCartCount()
    })
    .catch((error) => {
      console.error("Error adding to cart:", error)
      showQuickAddNotification("Erro ao adicionar produto ao carrinho", "error")
    })
    .finally(() => {
      // Hide loading and re-enable button
      if (loadingElement) {
        loadingElement.classList.remove("active")
      }
      button.disabled = false
    })
}

function showQuickAddNotification(message, type) {
  // Create notification element
  const notification = document.createElement("div")
  notification.className = `quick-add-notification ${type}`
  notification.textContent = message
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${type === "success" ? "#4CAF50" : "#f44336"};
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 9999;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    transform: translateX(100%);
    transition: transform 0.3s ease;
  `

  document.body.appendChild(notification)

  // Animate in
  setTimeout(() => {
    notification.style.transform = "translateX(0)"
  }, 100)

  // Remove after 3 seconds
  setTimeout(() => {
    notification.style.transform = "translateX(100%)"
    setTimeout(() => {
      document.body.removeChild(notification)
    }, 300)
  }, 3000)
}

function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartCountElements = document.querySelectorAll(".cart-count, [data-cart-count]")
      cartCountElements.forEach((element) => {
        element.textContent = cart.item_count
      })
    })
    .catch((error) => console.error("Error updating cart count:", error))
}
